var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip-group',_vm._l((_vm.users),function(user){return _c('v-chip',{key:user.value,attrs:{"small":"","dark":_vm.dark,"color":user.color}},[_vm._v(" "+_vm._s(user.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }